import { useState } from "react"
import axiosInstance from "../../../services/axios-client"
import { toast } from "react-toastify"
import { useNavigate } from "react-router-dom"

const useHomepageForm = () => {
    const navigate = useNavigate()
    const [payload, setPayload] = useState({
        Title: '',
        Order: '',
        Active: undefined,
        FileLink: '',
        FileName: ''
    })
    const [selectedFile, setSelectedFile] = useState(null)
    const [previewImage, setPreviewImage] = useState(null)
    const [isSaving, setIsSaving] = useState(false)
    const [activeOptions, setActiveOptions] = useState([
        {
            'label': 'Active',
            'value': true
        },
        {
            'label': 'Not Active',
            'value': false
        },
    ])

    const onChangeHandler = (e) => {
        if (e.target.name === "Order") {
            setPayload({ ...payload, [e.target.name]: parseInt(e.target.value) })
        } else {
            setPayload({ ...payload, [e.target.name]: e.target.value })
        }
    }

    const handleSelectStatus = (value) => {
        setPayload({
            ...payload,
            Active: value
        })
    };

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        if (file) {
            setSelectedFile(file);
            // Create preview URL for the new image
            const reader = new FileReader();
            reader.onloadend = () => {
                setPreviewImage(reader.result);
            };
            reader.readAsDataURL(file);
        }
    };

    const getAnnouncement = async (id) => {
        try {
            let res = await axiosInstance.get(`/auth/announcements/${id}?t=${Date.now()}`)
            if (res.status === 200) {
                setPayload(res.data.data)
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        }
    }

    const postAnnouncement = async (e) => {
        e.preventDefault()
        setIsSaving(true)
        try {
            if (selectedFile) {
                const formData = new FormData();
                formData.append("file", selectedFile);
                formData.append("payload", JSON.stringify(payload))

                let res = await axiosInstance.post('/auth/announcements', formData)
                if (res.status === 200) {
                    toast.success("Success Create Announcement")
                    navigate(-1, { state: { refresh: true } })
                }
            } else {
                toast.error("You should choose file to be uploaded")
            }
        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
        }
    }

    const putAnnouncement = async (e) => {
        e.preventDefault()
        setIsSaving(true)
        try {
            if (selectedFile) {
                const formData = new FormData();

                formData.append("file", selectedFile);
                formData.append("payload", JSON.stringify(payload))

                let res = await axiosInstance.put('/auth/announcements', formData)
                if (res.status === 200) {
                    toast.success("Success Update Announcement")
                    navigate(-1, { state: { refresh: true } })
                }
            } else {
                const formData = new FormData();
                formData.append("payload", JSON.stringify(payload))

                let res = await axiosInstance.put('/auth/announcements', formData)
                if (res.status === 200) {
                    toast.success("Success Update Announcement")
                    navigate(-1, { state: { refresh: true } })
                }
            }

        } catch (error) {
            if (error.response) {
                toast.error(error?.response?.data?.status?.description)
            } else if (error.message) {
                toast.error(error.message)
            } else {
                toast.error(error)
            }
        } finally {
            setIsSaving(false)
        }
    }

    return {
        payload,
        activeOptions,
        previewImage,
        handleSelectStatus,
        handleFileChange,
        onChangeHandler,
        postAnnouncement,
        putAnnouncement,
        isSaving,
        getAnnouncement,
    }
}

export default useHomepageForm